/**
 * Up-to-two-character avatar initials for `displayName`. Trims leading and
 * trailing whitespace before splitting so a name that's only whitespace
 * (technically valid against the `min(1)` schema) doesn't produce a glyph
 * that pretends the user has no name. Returns an empty string in that
 * case so the caller can decide on its own placeholder (avatar icon,
 * neutral background, …) instead of a literal "?" in the badge.
 */
export function getInitials(displayName: string | undefined): string {
  if (!displayName) return "";
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return (
    parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)
  ).toUpperCase();
}
